// Offline queue flush via the existing /offline/sync/push replay engine (P9.4).
import { useCallback, useState } from "react";
import { api } from "@/lib/api";
import { pendingSales, markSale, getMeta, clearSynced } from "@/lib/offlineDb";

export function useQueueFlush(online) {
  const [flushing, setFlushing] = useState(false);
  const [conflicts, setConflicts] = useState(0);

  const flush = useCallback(async () => {
    if (!online || flushing) return { synced: 0, conflicts: 0 };
    const device_id = await getMeta("offline_device_id");
    const pend = await pendingSales();
    if (!device_id || pend.length === 0) return { synced: 0, conflicts: 0 };
    setFlushing(true);
    let synced = 0, conf = 0;
    try {
      const items = pend.map((s) => ({
        entity_type: "sale", operation: "create",
        client_txn_id: s.client_txn_id, payload: s.payload,
      }));
      const { data } = await api.post("/offline/sync/push", { device_id, items });
      for (const r of data?.results || []) {
        if (r.status === "Synced" || r.status === "Duplicate") {
          await markSale(r.client_txn_id, { status: "Synced", synced_at: new Date().toISOString(), ref: r.ref });
          synced++;
        } else if (r.status === "Conflict") {
          await markSale(r.client_txn_id, { status: "Conflict", conflict_id: r.conflict_id });
          conf++;
        } else {
          const cur = pend.find((p) => p.client_txn_id === r.client_txn_id);
          await markSale(r.client_txn_id, { status: "Failed", attempts: (cur?.attempts || 0) + 1, error: r.error });
        }
      }
      await clearSynced();
      setConflicts((c) => c + conf);
    } catch (_) {
      // network blip — leave items Pending for next reconnect/backoff
    } finally {
      setFlushing(false);
    }
    return { synced, conflicts: conf };
  }, [online, flushing]);

  return { flush, flushing, conflicts };
}
